import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';
//import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { AppRoutingModule } from './routes/app-routing.module';
import { HeaderComponent } from './components/reusable/header/header.component';
import { FooterComponent } from './components/reusable/footer/footer.component';
import { ProposalUpdateComponent } from './components/proposal-update/proposal-update.component';
import { CreateProposalComponent } from './components/proposal-update/create-proposal/create-proposal.component';
import { UploadExcelComponent } from './components/proposal-update/upload-excel/upload-excel.component';
import { TextConfComponent } from './components/proposal-update/text-conf/text-conf.component';
import { DeepDiveComponent } from './components/deep-dive/deep-dive.component';
import { AppComponent } from './app.component';
import { AppConfigService } from './services/app-config.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PropSummaryComponent } from './components/prop-summary/prop-summary.component';
import { MsalApplicationModule } from './Auth/msal-application.module';
import { AuthModule } from './auth/auth.module';
import { SessionService } from './services/session.service';
import { AppConfig } from './auth/app.config';
import { DonutChartComponent } from './d3-components/doughnut.component';
import { RebarInterceptor } from './services/RebarInterceptor';
import { AutomationOpportunitiesComponent } from './components/automation-opportunities/automation-opportunities.component';
import { D3ChartComponent } from './d3-components/d3-chart/d3-chart.component';
import { HundredPercentBarChartComponent } from './d3-components/100-bar-chart/100-bar-chart.component';
import { HundredPercentColumnChartComponent } from './d3-components/100-column-chart/100-column-chart.component';
import { HundredPercentStackedbarChartComponent } from './d3-components/100-stackedbar-chart/100-stackedbar-chart.component';
import { HundredPercentStackedcolumnChartComponent } from './d3-components/100-stackedcolumn-chart/100-stackedcolumn-chart.component';
import { BarChartComponent } from './d3-components/bar-chart/bar-chart.component';
import { ColumnChartComponent } from './d3-components/column-chart/column-chart.component';
import { ComboChartComponent } from './d3-components/combo-chart/combo-chart.component';
import { ForecastChartComponent } from './d3-components/forecast-chart/forecast-chart.component';
import { HeatmapChartComponent } from './d3-components/heatmap-chart/heatmap-chart.component';
import { LineChartComponent } from './d3-components/line-chart/line-chart.component';
import { PieChartComponent } from './d3-components/pie-chart/pie-chart.component';
import { PieLabelChartComponent } from './d3-components/pie-label-chart/pie-label-chart.component';
import { StackedareaChartComponent } from './d3-components/stackedarea-chart/stackedarea-chart.component';
import { StackedbarChartComponent } from './d3-components/stackedbar-chart/stackedbar-chart.component';
import { StackedcolumnChartComponent } from './d3-components/stackedcolumn-chart/stackedcolumn-chart.component';
import { SubcategoryTreemapChartComponent } from './d3-components/subcategory-treeMap-chart/subcategory-treeMap-chart.component';
import { TreemapChartComponent } from './d3-components/treemap-chart/treemap-chart.component';
import { TreemapSummaryComponent } from './d3-components/treemap-summary/treemap-summary.component';
import { TrendChartComponent } from './d3-components/trend-chart/trend-chart.component';
import { WeightageChartComponent } from './d3-components/weightage-chart/weightage-chart.component';
import { TreeModule } from 'ng2-tree';
import { ScopeSelectorService } from './services/ScopeSelectorService';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SubcategoryColumnChartComponent } from './d3-components/subcategory-column-chart/subcategory-column-chart.component';
import { SubcategoryBarChartComponent } from './d3-components/subcategory-bar-chart/subcategory-bar-chart.component';
import { E2eTextconfigComponent } from './components/proposal-update/e2e-textconfig/e2e-textconfig.component';
import { AddInsightsComponent } from './components/add-insights/add-insights.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
declare var bootbox: any;
import { ParetoChartComponent } from './d3-components/pareto-chart/ParetoChartComponent';
import { WordChartComponent } from './d3-components/word-chart/WordChartComponent';
import { SubParetoChartComponent } from './d3-components/SubParetoChart/SubParetoChartComponent';
import { TextAnalysisTrendChartComponent } from './d3-components/TextAnalysisTrend-chart/TextAnalysisTrend-chart';
import { AgGridModule } from 'ag-grid-angular';
import { EllipsisModule } from 'ngx-ellipsis';
import { MatExpansionModule } from '@angular/material/expansion';
import { AccessDeniedComponent } from './components/reusable/access-denied/access-denied.component';
import { ErrorComponent } from './components/reusable/error/error.component';
import { TrendAnalysisComponent } from './components/trend-analysis/trend-analysis.component';
import { LandingComponent } from './components/landing/landing.component';
import { MultilevelPiechartComponent } from './d3-components/multilevel-piechart/multilevel-piechart.component';
import { TextAnalysisComponent } from './components/text-analysis/text-analysis.component';
import { ParetoChartEXPComponent } from './d3-components/paretoChartExp/ParetoChartComponent';
import { TicketCountPipe } from './custom-pipes/ticketcountfilter';
import { AttributeMappingComponent } from './components/proposal-update/attribute-mapping/attribute-mapping.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { DoughnutComponent } from './d3-components/doughnut/doughnut.component';
import { ParetoExpendedComponent } from './d3-components/pareto-expended/ParetoExpendedComponent';
import { ParetoComponent } from './d3-components/pareto/ParetoComponent';
import { TreemapKeyComponent } from './d3-components/treemap-key/treemap-key.component';
import { EditDiyProposalComponent } from './components/proposal-update/edit-diy-proposal/edit-diy-proposal.component';
import { SpeedometerChartComponent } from './d3-components/speedometer-chart/speedometer-chart.component';
import { DataQualityAssessmentComponent } from './components/data-quality-assessment/data-quality-assessment.component';
import { Bar3DChartComponent } from './d3-components/3d-bar-chart/3d-bar-chart.component';
import { DoughnutChartComponent } from  './d3-components/doughnut-clickable-chart/doughnut-clickable-chart.component';
import { HorizontalbarchartComponent } from  './d3-components/horizontal-bar-chart/horizontal-bar-chart.component';

declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
  ngModule: Type<T>;
  providers?: Provider[];
  }
  }
  

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ProposalUpdateComponent,
    CreateProposalComponent,
    UploadExcelComponent,
    TextConfComponent,
    DeepDiveComponent,
    PropSummaryComponent,
    DonutChartComponent,
    AutomationOpportunitiesComponent,
    D3ChartComponent,
    HundredPercentBarChartComponent,
    HundredPercentColumnChartComponent,
    HundredPercentStackedbarChartComponent,
    HundredPercentStackedcolumnChartComponent,
    BarChartComponent,
    ColumnChartComponent,
    ComboChartComponent,
    ForecastChartComponent,
    HeatmapChartComponent,
    LineChartComponent,
    PieChartComponent,
    PieLabelChartComponent,
    StackedareaChartComponent,
    StackedbarChartComponent,
    StackedcolumnChartComponent,
    SubcategoryTreemapChartComponent,
    TreemapChartComponent,
    TreemapSummaryComponent,
    TrendChartComponent,
    WeightageChartComponent,
    SubcategoryColumnChartComponent,
    SubcategoryBarChartComponent,
    E2eTextconfigComponent,
    DonutChartComponent,
    ParetoChartComponent,
    WordChartComponent,
    TextAnalysisTrendChartComponent,
    SubParetoChartComponent,
    AddInsightsComponent,
    AccessDeniedComponent,
    ErrorComponent,
    LandingComponent,
    MultilevelPiechartComponent,
    TrendAnalysisComponent,
    TextAnalysisComponent,
    ParetoChartEXPComponent,
    TicketCountPipe,
    AttributeMappingComponent,    
    ParetoExpendedComponent,
    DoughnutComponent,
    ParetoComponent,
    TreemapKeyComponent,
    EditDiyProposalComponent,
    DataQualityAssessmentComponent,
    Bar3DChartComponent,   
    SpeedometerChartComponent,
    DoughnutChartComponent,
    HorizontalbarchartComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    MsalApplicationModule,
    AuthModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    // D3Pie,
    TreeModule,
    AgGridModule.withComponents([]),
    NgMultiSelectDropDownModule.forRoot(),
    // D3Pie
    EllipsisModule,
    ClickOutsideModule    
  ],
  providers: [AppConfig, AppConfigService, SessionService, ScopeSelectorService,
    {
      provide: APP_INITIALIZER,
      useFactory: (appconfigService: AppConfigService) => () => appconfigService.load(),
      deps: [AppConfigService], multi: true
    }
  ],
  bootstrap: [AppComponent]
  // declarations: [AppComponent, ExportreportComponent]
  // providers: [AppConfig, AppConfigService, SessionService, ScopeSelectorService,
  //   {
  //     provide: APP_INITIALIZER,
  //     useFactory: (config: AppConfigService) => () => config.load(),
  //     deps: [AppConfigService], multi: true
  //   },
  //   // {
  //   //   provide: HTTP_INTERCEPTORS,
  //   //   useClass: RebarInterceptor,
  //   //   multi: true
  //   // }
  // ],
  // bootstrap: [AppComponent]
})
export class AppModule { }
